// @ts-nocheck

import { flashMessageActionCreators } from '../actions';
import { Target } from '../client';
import { __ } from '../i18n/l10n';
import { UserActionTypes } from '../types/actions/user';
import { FlashMessageScopes, FlashMessageSeverities, FlashMessageTypes } from '../types/flashmessage';
import { makeWapiCall } from '../utils/api';

const { setDisconnectedHeader } = window;

export type UserSetLastSessionSettledBetsAction = () => {
  type: typeof UserActionTypes.SET_LAST_SESSION_SETTLED_BETS;
  payload: {
    lastSessionSettledBets: Array<string>;
  };
};

const setLastSessionSettledBets = (lastSessionSettledBets) => ({
  type: UserActionTypes.SET_LAST_SESSION_SETTLED_BETS,
  payload: {
    lastSessionSettledBets,
  },
});

export type UserClearLastSessionSettledBetsAction = () => {
  type: typeof UserActionTypes.CLEAR_LAST_SESSION_SETTLED_BETS;
};

const clearLastSessionSettledBets = () => ({
  type: UserActionTypes.CLEAR_LAST_SESSION_SETTLED_BETS,
});

export type UserSetEmbeddedNotificationTarget = () => {
  type: typeof UserActionTypes.SET_EMBEDDED_NOTIFICATION_TARGET;
  payload: {
    embeddedNotificationTarget: string;
  };
};

const setEmbeddedNotificationTarget = (embeddedNotificationTarget) => ({
  type: UserActionTypes.SET_EMBEDDED_NOTIFICATION_TARGET,
  payload: { embeddedNotificationTarget },
});

export const setConnected = () => ({
  type: UserActionTypes.SET_CONNECTED,
});

const setDisconnected = () => (dispatch) => {
  if (typeof setDisconnectedHeader === 'function' && Target.__MOBILE__ === false) {
    setDisconnectedHeader();
  }
  dispatch({
    type: UserActionTypes.SET_DISCONNECTED,
  });
};

const setFlagNewUser = () => ({
  type: UserActionTypes.SET_FLAG_NEWUSER,
});

const setBalance =
  ({ balance, balanceCash, balanceBonus, freebetBankroll, origin, type }) =>
  (dispatch, getState) => {
    if (typeof window.updateBankroll === 'function' && Target.__MOBILE__ === false) {
      if (balance !== undefined && balance !== null) {
        const isRealMoney = getState().user.realMoney;
        window.updateBankroll(balance, isRealMoney ? 'real' : 'play');
      }
    }

    if (typeof window.updateFreebetBankroll === 'function' && Target.__MOBILE__ === false) {
      if (freebetBankroll !== undefined && freebetBankroll !== null) {
        window.updateFreebetBankroll(freebetBankroll);
      }
    }

    dispatch({
      type: UserActionTypes.SET_BANKROLL,
      payload: {
        balance,
        balanceCash,
        balanceBonus,
        freebetBankroll,
        origin,
        type,
      },
    });
  };

const setPresets = (presets) => ({
  type: UserActionTypes.SET_PRESETS,
  payload: {
    presets,
  },
});

const setRealMoney = (realMoney) => ({
  type: UserActionTypes.SET_REALMONEY,
  payload: {
    realMoney,
  },
});

const setPreferences = (id, prefs) => ({
  type: UserActionTypes.SET_PREFERENCES,
  payload: {
    id,
    prefs,
  },
});

export const clearPreferences = (id) => ({
  type: UserActionTypes.CLEAR_PREFERENCES,
  payload: {
    id,
  },
});

const setCalendarHourPreference = (hour) => ({
  type: UserActionTypes.SET_CALENDAR_HOUR_PREFERENCE,
  payload: {
    hour,
  },
});

const setMessages = (messages) => ({
  type: UserActionTypes.SET_MESSAGES,
  payload: {
    messages,
  },
});

const ackMessage = () => ({
  type: UserActionTypes.ACK_MESSAGE,
});

const setMustValidateEvents = (value = true) => ({
  type: UserActionTypes.SET_MUST_VALIDATE_EVENTS,
  payload: {
    value,
  },
});

const setMustValidateCGU = (value = true) => ({
  type: UserActionTypes.SET_MUST_VALIDATE_CGU,
  payload: {
    value,
  },
});

export const setShowWinamaxTv = (value) => ({
  type: UserActionTypes.SET_PREFERENCES,
  payload: {
    id: 'showWTV',
    prefs: value,
  },
});

export const setNickname = (value) => ({
  type: UserActionTypes.SET_NICKNAME,
  payload: {
    nickname: value,
  },
});

const setConnecting = (value) => ({
  type: UserActionTypes.SET_CONNECTING,
  payload: {
    connecting: value,
  },
});

const setAffiliation = ({ godfatherAmount, godsonAmount }) => ({
  type: UserActionTypes.SET_AFFILIATION,
  payload: {
    godfatherAmount,
    godsonAmount,
  },
});

const setMiles = ({
  miles: {
    thisMonth: { totalMiles },
    year: { totalMiles: yearTotalMiles },
    total: { available },
  },
  vip: {
    currentLevel: { name, milesToKeepLevel },
    nextLevel: { milesToNextLevel, name: nextRankName } = {},
  },
}) => ({
  type: UserActionTypes.SET_MILES,
  payload: {
    thisMonthTotalMiles: totalMiles,
    thisYearTotalMiles: yearTotalMiles,
    availableMiles: available,
    name,
    nextRankName,
    milesToKeepLevel,
    milesToNextLevel,
  },
});

const setBonuses = ({ bonuses, bonusCodes }) => ({
  type: UserActionTypes.SET_BONUSES,
  payload: {
    bonuses,
    bonusCodes,
  },
});

const setTickets = ({ play, real }) => ({
  type: UserActionTypes.SET_TICKETS,
  payload: {
    play,
    real,
  },
});

const getUserDataKo = (err) => ({
  type: UserActionTypes.GET_USER_DATA_KO,
  payload: {
    err,
  },
});

const setCC = (cc) => ({
  type: UserActionTypes.SET_CC,
  payload: {
    cc,
  },
});

const setSessionId = (sessionId) => ({
  type: UserActionTypes.SET_SESSIONID,
  payload: {
    sessionId,
  },
});

export const sendMarketingCode =
  ({ jwt, code, next }) =>
  async (dispatch) => {
    if (jwt && code) {
      const delay = 1000; // ms

      try {
        const response = await makeWapiCall({
          namespace: 'operator/bonuses',
          method: 'UseMarketingCode',
          params: {
            jwt,
            marketing_code: code,
          },
        });

        const { success } = response ?? {};

        setTimeout(() => {
          if (success) {
            dispatch(
              flashMessageActionCreators.addMessage({
                scope: FlashMessageScopes.QR,
                severity: FlashMessageSeverities.NOTICE,
                type: FlashMessageTypes.DISMISS_AUTO,
                message: __('Your bonus code has been accepted'),
              }),
            );
          } else {
            dispatch(
              flashMessageActionCreators.addMessage({
                scope: FlashMessageScopes.QR,
                severity: FlashMessageSeverities.ERROR,
                type: FlashMessageTypes.DISMISS_AUTO,
                message: __('This code is not a Winamax bonus code or has already been credited'),
              }),
            );
          }
          next();
        }, delay);
      } catch (error) {
        setTimeout(() => {
          dispatch(
            flashMessageActionCreators.addMessage({
              scope: FlashMessageScopes.QR,
              severity: FlashMessageSeverities.ERROR,
              type: FlashMessageTypes.DISMISS_AUTO,
              message: __('An error occurred, please try again.'),
            }),
          );
          next();
        }, delay);
      }
    }
  };

export const setDidReceivedUserData = (didReceivedUserData) => ({
  type: UserActionTypes.SET_DID_RECEIVED_DATA,
  payload: {
    didReceivedUserData,
  },
});

export const togglDisplayBetSlidersByDefaultOption = () => ({
  type: UserActionTypes.TOGGLE_OPTION_DISPLAY_SLIDERS,
});

export default {
  setConnected,
  setDisconnected,
  setFlagNewUser,
  setConnecting,
  setNickname,
  setBalance,
  setPresets,
  setRealMoney,
  setPreferences,
  clearPreferences,
  setCalendarHourPreference,
  setShowWinamaxTv,
  setMustValidateEvents,
  setMustValidateCGU,
  setMessages,
  ackMessage,
  setLastSessionSettledBets,
  clearLastSessionSettledBets,
  setEmbeddedNotificationTarget,
  setAffiliation,
  setMiles,
  setBonuses,
  getUserDataKo,
  setCC,
  setSessionId,
  setTickets,
  sendMarketingCode,
  togglDisplayBetSlidersByDefaultOption,
};
